import React from "react";

export const getStatusClass = (days) => {
  if (days === 0) return "bg-gray100 text-gray700";
  if (days <= 7) return "bg-error50 text-error600";
  if (days <= 14) return "bg-warning50 text-warning700";
  return "bg-success50 text-success700";
};

export const getStatusText = (student, user) => {
  const subscription = student?.subscription || {};

  const invitePending =
    student?.invite?.status !== "approved" &&
    student?.invite?.senderId === user?.id;
  const hasSub = !!subscription.id;
  const isCredits = subscription.platform === "Credits";
  const isStripe = subscription.platform === "Stripe";
  const autoRenewal = subscription.autoRenewal === true;
  const sameCoach = subscription.coachId === user?.id;
  const isFreeStudent = student?.subscriptionType?.includes("free");
  const sessionsCount = Array.isArray(student?.sessionIds)
    ? student.sessionIds.length
    : 0;

  const byYou = <span className="text-grayTrue500">(by you)</span>;
  const byOther = <span className="text-grayTrue500">(by other)</span>;

  // 1) Pending invitation cases
  if (invitePending) {
    if (hasSub) {
      return sameCoach ? (
        <>Credit applied, pending account {byYou}</>
      ) : (
        <>Credit applied {byOther}, pending account</>
      );
    }
    return <>Pending account</>;
  }

  // 2) Free tier
  if (isFreeStudent) {
    return sameCoach || !hasSub ? (
      <>Free account</>
    ) : (
      <>Free account {byOther}</>
    );
  }

  // 3) Auto-renew
  if (autoRenewal) {
    if (isCredits && sameCoach) {
      return <>Auto-renew {byYou}</>;
    }
    return <>Auto-renew {byOther}</>;
  }

  // 4) Credit accepted
  // if (isCredits && sessionsCount > 0) {
  //   return sameCoach ? <>Credit accepted</> : <>Credit accepted {byOther}</>;
  // }

  if (isCredits) {
    return sameCoach ? <>Credit applied</> : <>Credit applied {byOther}</>;
  }

  // 5) Credit applied (no sessions yet, invite already approved)
  // if (isCredits && hasSub && sessionsCount < 1) {
  //   return sameCoach ? (
  //     <>Credit applied, pending account {byYou}</>
  //   ) : (
  //     <>Credit applied {byOther}, pending account</>
  //   );
  // }

  // Default
  return <>Credit applied {byOther}</>;
};
